import styled from "@emotion/styled"
import { Desktop, ImageContainer, Mobile, NewText, TitleWithLine } from "ui"
import { sharedColors } from "ui/theme/colors"
import { removePTags } from "utils/utils"

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: minmax(auto, 450px) 1fr;
  }
  @media (min-width: 1160px) {
    grid-template-columns: minmax(auto, 613px) 1fr;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    grid-template-columns: minmax(auto, 920px) 1fr;
  }
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* background-color: ${sharedColors.veryLightGray}; */
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-right: 146px;
    padding-left: 100px;
  }
  @media (min-width: 1920px) {
    padding-right: 220px;
    padding-left: 146px;
  }
`

const ImgCont = styled.div`
  transform-origin: bottom;
  ${(props) => props.theme.breakpoints.up("md")} {
    transform: translateY(-70px);
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    transform: translateY(-140px);
  }
`
type Props = {
  content: {
    headline: string | undefined
    body: string | undefined
    image: string | undefined
    subtitle?: string
  }
}

const StyledSubTitle = styled(NewText)`
  p {
    margin: 0;
  }
  h3 {
    font-weight: 500;
    color: #0050c9;
    margin-bottom: 0;
  }
`
const StyledNewText = styled(NewText)`
  p {
    margin: 0;
  }
  h3 {
    font-weight: 500;
    color: #0050c9;
    margin-bottom: 0;
  }
`

function ImageText({ content }: Props) {
  if (!content.image) {
    return null
  }
  return (
    <StyledGrid>
      <ImgCont>
        <ImageContainer
          mediumHeight={613}
          desktopUrl={content.image || ""}
          sm={true}
          height={920}
          emptyAlt={true}
          mobileHeight={375}
        />
      </ImgCont>
      <StyledContent>
        <Desktop>
          <NewText
            component={"h2"}
            desktopFontSize={32}
            largeDesktopFontSize={48}
            desktopLineHeight="44.8px"
            largeDesktopLineHeight="48px"
            color="black"
          >
            {removePTags(content.headline || "")}
          </NewText>
        </Desktop>
        <Mobile>
          <TitleWithLine
            title={removePTags(content.headline || "")}
            titleFontSize={32}
            largeDesktopFontSize={48}
            titleColor="black"
          />
        </Mobile>
        <StyledSubTitle
          component={"p"}
          largeDesktopFontSize={18}
          largeDesktopLineHeight="25.2px"
          desktopFontSize={12}
          desktopLineHeight={"16px"}
          color="black"
          mobileFontSize={16}
          mobileLineHeight={"24px"}
          dangerouslySetInnerHTML={{ __html: content.subtitle || "" }}
        />
        <StyledNewText
          component={"p"}
          desktopFontSize={12}
          color="black"
          largeDesktopFontSize={18}
          largeDesktopLineHeight="25.2px"
          desktopLineHeight={"16px"}
          mobileFontSize={16}
          mobileLineHeight={"24px"}
          dangerouslySetInnerHTML={{ __html: content.body || "" }}
        />
      </StyledContent>
    </StyledGrid>
  )
}

export default ImageText
